export default __webpack_public_path__ + "static/media/guideRejectedIcon.3ca5948f.svg";